import { useEffect } from "react";
import { Control, useWatch } from "react-hook-form";

export const useFormWatch = ({
    name,
    dependsOn,
    control,
    onClear
}: {
    name: string;
    dependsOn: string[];
    control: Control;
    onClear?: () => void;
}) => {
    const watch = useWatch({ control });

    dependsOn.forEach((item) => {
        useEffect(() => {
            const value = control.getValues(name);
            const dependsOnValue = control.getValues(item);
            const initialDependsOnValue = control.defaultValuesRef.current[item];

            if (dependsOnValue !== initialDependsOnValue) {
                if (typeof value === "string") {
                    control.setValue(name, "");
                }

                if (Array.isArray(value)) {
                    control.setValue(name, []);
                }

                if (onClear) {
                    onClear();
                }
            }
        }, [watch[item]]);
    });
};
